import React, { Component } from 'react'
import Input from './../input'
import BVRadio from './../bvradio'
import { Form } from 'formsy-react'
import _ from 'underscore'
import AdvancedOptionsForm from './../forms/advancedoptionsform'

class NexcessForm extends Component{
	constructor(props){
		super(props)
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
	}

	fetchValue(key) {
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key) {
		const { errors } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	ftpForm() {
		const { error } = this.props
		return <div className="pb-1">
			{ error && <div className="pb-2 mb-2 font12">{error}</div> }
			<div className="row">
				<div className={this.getClassName('newurl')}>
					<i className="mdi mdi-web"></i>
					<Input
						type="text"
						name="newurl"
						title="Destination Site URL"
						placeholder="Eg. www.google.com"
						classname=""
						value={this.fetchValue('newurl')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('address')}>
					<i className="mdi mdi-server"></i>
					<Input
						type="text"
						name="address"
						title="Host/Server Address"
						placeholder="Eg. 127.0.0.1"
						classname=""
						value={this.fetchValue('address')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('type')}>
					<BVRadio
						name="type"
						title="FTP Type"
						items={['sftp', 'ftps']}
						value={this.fetchValue('type') || 'sftp'}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('username')}>
					<i className="mdi mdi-account"></i>
					<Input
						type="text"
						name="username"
						title="FTP Username"
						placeholder="Enter FTP username here"
						classname=""
						value={this.fetchValue('username')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('passwd')}>
					<i className="mdi mdi-lock"></i>
					<Input
						type="password"
						name="passwd"
						title="FTP Password"
						placeholder="Enter FTP password here"
						classname=""
						value={this.fetchValue('passwd')}
					/>
				</div>
			</div>
		</div>
	}

	render() {
		const { migrate, handleSubmit, loading, error, errors, fields, params, directoryList, getDirectoryList, changeSelection,
			tablesList, getTablesList, changeTableSelection, directoriesSelectAllDisabled, allDirectoriesSelected, selectAllDirectories,
			tablesSelectAllDisabled, allTablesSelected, selectAllTables } = this.props
		return <div className="bv-body lw">
			{loading}
			<div className="col-xs-7 col-md-4 center-dom text-center container bv-form" >
				<Form onSubmit={handleSubmit} className="bv-form-label-left-align mg-form px-15">
					<div>
						{this.ftpForm()}
						<div className="row hide-field">
							<Input
								type="hidden"
								name="migrate"
								value="nexcess"
								title=""
								placeholder=""
								classname=""
							/>
						</div>
						<AdvancedOptionsForm
							migrate={migrate}
							errors={errors}
							fields={fields}
							params={params}
							directoryList={directoryList}
							tablesList={tablesList}
							getDirectoryList={getDirectoryList}
							getTablesList={getTablesList}
							changeSelection={changeSelection}
							changeTableSelection={changeTableSelection}
							directoriesSelectAllDisabled={directoriesSelectAllDisabled}
							allDirectoriesSelected={allDirectoriesSelected}
							selectAllDirectories={selectAllDirectories}
							tablesSelectAllDisabled={tablesSelectAllDisabled}
							allTablesSelected={allTablesSelected}
							selectAllTables={selectAllTables}
						/>
						<input type="submit" value="Migrate" className="bv-primary-button"/>
					</div>
				</Form>
			</div>
		</div>
	}
}

export default NexcessForm
